import { useLocation } from "react-router-dom";
import { NavBarItem } from "../NavBar/NavBar";

interface TitleProp {
    items: NavBarItem[];
}

export const Title = ({items}: TitleProp) => {
    const location = useLocation();
    
    const isActive = (path: string) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
    const activeItem = items.find((item) => isActive(item.route));
    
    return activeItem ? <h1>{activeItem.name}</h1> : null;
}